import Lockr from 'lockr';
import axios from 'axios';

const token = Lockr.get('token');
export const benoitAxios = axios.create({
    baseURL: `${process.env.REACT_APP_BENOIT_URL}`,
    ...(token && { headers: { Authorization: `Bearer ${token}` } }),
});
